/* One message at a time. Hidden messages are never focusable. */
(() => {
  if (customElements.get('az-top-bar')) return;
  customElements.define('az-top-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-top-slide]')];
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.editor = Boolean(window.Shopify?.designMode);
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.toggle = this.querySelector('[data-top-toggle]');
      this.dataset.multiple = String(this.slides.length > 1);
      this.dataset.controls = 'false';
      this.select(0);
      if (this.slides.length < 2) return;
      this.querySelector('.az-top-bar__controls').hidden = false;
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && this.dataset.hoverPause === 'true') { this.hovered = true; this.sync(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.sync(); }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reduced.addEventListener('change', () => this.sync(), options);
      (this.closest('.shopify-section') || this).addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.select(index); this.sync(); }
      }, options);
      this.sync();
    }
    select(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
    }
    sync() {
      clearTimeout(this.timer);
      this.dataset.reduced = String(this.reduced.matches);
      const automatic = this.dataset.motion === 'true' && !this.reduced.matches && !this.editor;
      this.toggle.hidden = !automatic;
      this.querySelector('.az-top-bar__controls').hidden = !automatic;
      this.dataset.controls = String(automatic);
      this.toggle.setAttribute('aria-pressed', String(this.paused));
      this.toggle.setAttribute('aria-label', this.paused ? 'Nachrichten fortsetzen' : 'Nachrichten pausieren');
      if (!automatic || this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => {
        this.select((this.index + 1) % this.slides.length);
        this.sync();
      }, Math.max(3, Number(this.dataset.interval) || 5) * 1000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.abort = null; }
  });
})();
